import { useTranslation } from "react-i18next";
import EditContractModelModal from "./EditContractModelModal"
import Modal from "components/commons/Modal";
import EntityFingerprint from "components/commons/EntityFingerprint";

export default function ContractModelCard({ contractModel, onDelete}) {

    const [t, i18n] = useTranslation("global", "absenceReport");

    return (
        <>
            <div className="card bg-dark mb-4">
                <div className="card-header row">
                    <div className="col-auto">
                        <h3><i className="fa-solid fa-file-lines text-accent"></i> {contractModel.name}</h3>

                    </div>
                    <div className="col text-end">
                        <EditContractModelModal data={contractModel} /> <></>
            
                        <Modal
                            modalId={"contract_model_delete_" + contractModel.guid.substr(contractModel.guid.length - 4)}
                            locked={contractModel.workerClasses.some(workerClass => workerClass.active > 0) == true}
                            modalLocked = {contractModel.workerClasses.some(workerClass => workerClass.active > 0)}
                            iconOnly = {true}
                            buttonIcon={<i className="fa-solid fa-trash"></i>}
                            buttonClass="btn btn-danger"
                            buttonLabel={t("action.delete")}
                            body={t("helper.generic_entity_deleting")}
                            onConfirm={() => onDelete(contractModel.guid)}
                        />
                    </div>
                </div>

                <div className="card-body">
                    <div className="row">
                        <div className="col-sm-5">
                            <p>{contractModel.description}</p>
                            {t("absenceReport:helper.based_on")} <h5 className="text-accent"><i className="fa-solid fa-clock"></i> {contractModel.baseHours} <span className="text-muted"> {t("absenceReport:property.weekly_hours")}</span> </h5>

                        </div>


                        <div className="col-sm-5">

                            {
                                contractModel.workerClasses &&
                                <table className="table">
                                    <thead>
                                        <tr >
                                            <th><h6 className="text-accent"><i className="fa-solid fa-user-large"></i> {t("absenceReport:property.contractual_level")}</h6></th>
                                            <th>{t("absenceReport:entity.leaveReport.type.holidays")} </th>
                                            <th>{t("absenceReport:entity.leaveReport.type.timeOff")} </th>
                                            <th>{t("absenceReport:entity.leaveReport.type.abolished")} </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            contractModel.workerClasses?.map(workerClass => {
                                                return <tr key={workerClass.guid}>
                                                    <td>{workerClass.name}</td>
                                                    <td>{workerClass.holidaysHours}</td>
                                                    <td>{workerClass.rolHours}</td>
                                                    <td>{workerClass.leaveHours}</td>
                                                    {/* <td><b className={`${workerClass.active > 0 && "text-warning "}`}>{workerClass.active}</b> in uso </td> */}
                                                    {
                                                        workerClass.active > 0 &&
                                                        <td>
                                                            <span className="small ">{<i className="fa-solid fa-user-group"></i>}  {workerClass.active} </span>
                                                        </td>
                                                    }

                                                </tr>
                                            })
                                        }
                                    </tbody>
                                </table>
                            }
                        </div>

                    </div>
                </div>
                <div className="card-footer">
                    <EntityFingerprint guid={contractModel.guid}/>
                </div>
            </div >
        </>
    )
}